/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyTagDto } from '../../models/company-tag-dto';

export interface GetCompanyAssociatedTags$Params {
  id: number;
}

export function getCompanyAssociatedTags(http: HttpClient, rootUrl: string, params: GetCompanyAssociatedTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyTagDto>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyAssociatedTags.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyTagDto>>;
    })
  );
}

getCompanyAssociatedTags.PATH = '/api/companies/{id}/tags';
